import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NotificationService,
  LookupService
} from '../../../services/index';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { ValidationPartialComponent } from './validation-partial.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-abn-search-partial',
    templateUrl: './abn-search-partial.component.html',
    standalone: true,
    imports: [MatFormFieldModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatInputModule, ValidationPartialComponent, NgIf, MatButtonModule, MatButtonModule, MatProgressSpinnerModule, MatProgressSpinnerModule]
})
export class AbnSearchPartialComponent implements OnInit {

  @Input() public formGroup: UntypedFormGroup;
  @Input() public fieldName: string;
  @Input() public placeholderText: string;

  @Output() public abnResults = new EventEmitter<any>();

  loadingResults = false;

  constructor (private notificationService: NotificationService,
               private lookupService: LookupService) {
  }

  ngOnInit() {
  }

  searchAbnAcn() {
    if (this.formGroup.get(this.fieldName).value) {
      this.loadingResults = true;
      const query = this.formGroup.get(this.fieldName).value.replace(/ /g, '');
      this.lookupService.getBusinessDetails(query)
        .subscribe(
          businesses => {
            this.loadingResults = false;
            this.abnResults.emit(businesses);

            if (businesses.length === 1) {
              this.notificationService.toast('success', 'We have found results matching your query', 'Success' );
            } else if (businesses.length > 1) {
              this.notificationService.toast('success', 'We have found results matching your query', 'Success' );
            } else {
              this.notificationService.toast('error', 'There are no results matching your query', 'Error' );
            }
          },
          error => {
            this.loadingResults = false;
            console.log(error);
            this.notificationService.toast('error', 'There has been an error in searching your query', 'Error' );
          });
    } else {
      this.formGroup.get(this.fieldName).markAsTouched({ onlySelf: true });
      this.notificationService.toast('error', 'Please enter an ABN or ACN', 'Error' );
    }
  }
}
